<template>
  <div class="modal full-screen">
    <div class="flex-col flex-center">
      <FancySpinner />
      <h1>Locale<span class="fc-primary">.ai</span></h1>
      <section class="pad-20 flex-center">
        <label>Loading {{ caption || "..." }}</label>
      </section>
    </div>
  </div>
</template>

<script>
import FancySpinner from "@/components/global/views/FancySpinner";

export default {
  props: {
    caption: String,
  },
  components: {
    FancySpinner,
  },
};
</script>

<style></style>
